import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const SpamBehaviorPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">迷惑行為について</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              DONDONでは、すべてのお客様に安心・安全にご利用いただける環境を提供するため、各種サービスのご利用に際し、ガイドラインを設けております。<br/>
              また、他のお客様のご利用を妨げる行為や、ガイドラインに反する行為は「迷惑行為」として厳しく禁止しています。
            </div>
            <div className="flex flex-col justify-start items-start">
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                以下のページをよくご確認のうえ、ルールに沿ってご利用くださいますようお願いいたします。
              </div>
              <Link to={`/terms/guideline_listing${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">
                出品ガイドライン
              </Link>
              <Link to={`/terms/guideline_transaction${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">
                取引の流れ
              </Link>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品における主な迷惑行為</div>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              各ガイドラインに反する行為や、以下に該当する迷惑行為が確認された場合には、該当の出品を削除いたします。<br/>
              また、同様の行為が繰り返される場合や、悪質性が高いと判断される場合には、出品削除に加え、「出品機能の制限」などの対応を行います。<br/>
              ※すでに取引が成立している商品については、該当取引をキャンセルし、キャンセル料を徴収させていただきます。<br/>
              あらかじめご了承のうえ、ルールに則ったご利用をお願いいたします。
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">禁止品の出品</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="w-full justify-center text-black text-base font-normal leading-7">
                  ガイドラインで出品を禁止している商品は、出品することができません。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">販売意思のない出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  宣伝のみを目的とした出品や、すでに売却済みの商品を掲載する行為は、「販売の意思がない」と判断されるため不適切です。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">商品が手元にない状態での出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  外部の販売サイトからの直送や、配送代行サービスを利用した出品についても、「販売の意思がない」と判断されるため不適切です。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">商品ページ・タイトルが異なる出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  出品は、必ず該当する商品ページや正しいカテゴリ/タイトルの選択に従って行ってください。<br/>
                  商品ページと異なる内容での出品や、選択されたブランド・カテゴリと一致しない出品は、真贋鑑定や検品の妨げとなるため、不適切な出品とみなされる場合がございます。<br/>
                  ※また、DONDONで取り扱いのないタイトルや商品は出品できませんので、あらかじめご了承ください。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">知的財産権を侵害する出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  権利者の許諾を得ずに、ブランドのデザインを模したカスタム品を制作・出品する行為は、知的財産権の侵害に該当する可能性があります。<br/>
                  そのため、商標権や著作権などの知的財産権を侵害する商品は、DONDONでは出品できません。<br/>
                  権利保護の観点から、正規品でないアイテムの出品には十分ご注意ください。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">第三者の投稿文・画像を転載した出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  SNS投稿のスクリーンショットをはじめとする、投稿文や画像の無断転載・引用はご遠慮ください。<br/>
                  権利者の許可なく他者のコンテンツを使用することは、権利侵害に該当する可能性があります。<br/>
                  万が一権利者からの削除要請があった場合には、該当の出品を削除するとともに、投稿機能の制限等の対応を行うことがあります。<br/>
                  ※なお権利者以外からの削除要請には対応いたしかねますので、あらかじめご了承ください。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">出品情報の一貫性に欠ける出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  実際の販売価格と異なる金額を掲載したり、商品情報や画像が実物の状態と著しく異なる出品は不適切とみなされます。<br/>
                  また、商品の傷や汚れ・劣化の程度を意図的に隠す行為や、実際の状態とかけ離れた内容を記載することは購入者様に誤認を与える行為に該当します。<br/>
                  すべてのお客様に安心してご利用いただくため、正確かつ誠実な出品情報の記載をお願いいたします。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">同じ画像を用いた複数件の同時出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  中古商品の出品にあたっては、出品ごとに商品画像を撮影して掲載してください。<br/>
                  過去の出品画像を再利用したり、他の出品と一部でも画像が重複している場合は、不適切な出品として扱われ、本項目に該当することがあります。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">一出品一商品に反する出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  出品は、必ず1商品ごとにおこなってください。<br/>
                  異なる個体の商品画像を掲載したり、1つの出品ページに複数の商品を掲載して購入者様に選ばせる形式での出品は、不適切な出品とみなされ、本項目に該当する場合がございます。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">外部ツール/ソフトを用いた出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  外部ツールやソフトを利用した出品・編集・削除の操作はご遠慮ください。<br/>
                  公平な取引環境を維持するため、外部ツールやソフトを用いた操作は一切禁止しております。<br/>
                  また、これらのツールと類似する挙動が確認された場合や、サービスの運営に影響を及ぼすと判断された場合には、出品の削除やアカウントの利用制限を行うことがあります。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">本来の商品とは関係のない出品</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  補足説明や付属品欄には、実際の商品に無関係な提供物の記載はお控えください。<br/>
                  本来の商品と関係のない物品の提供を示唆する内容は、出品情報の正確性を損ない、購入者様に誤認や混乱を招く可能性があるため、不適切な行為とみなされます。
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">取引における主な迷惑行為</div>
            </div>
            <div className="w-full justify-center">
              <span className="text-black text-base font-normal leading-7">迷惑行為が確認された取引については、該当内容に応じて以下のような措置を講じる場合があります。<br/></span>
              <span className="text-black text-base font-normal leading-7">・取引のキャンセル<br/>・出品や購入機能の制限<br/>・アカウントの一時停止または利用停止 など<br/></span>
              <span className="text-black text-base font-normal leading-7">なお、講じる措置の内容は、確認された行為の内容や悪質性の程度に応じて異なります。</span>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">マネーロンダリング（資金洗浄）が疑われる取引</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  同一人物、または親族・関係者間による取引は、マネーロンダリングに該当する可能性があるため、禁止しております。<br/>
                  マネーロンダリングの疑いが確認された場合には、該当取引を即時キャンセルし、関連するアカウントの利用を全面的に制限させていただきます。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">発送・到着期限の超過によるキャンセル</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center">
                  <span className="text-black text-base font-normal leading-7">出品者様による商品発送には、「発送期限」と「到着期限」が設けられています。<br/>これらの期限を超過した場合、取引はキャンセルとなり、キャンセル料（商品代金の一部）を徴収いたします。<br/>また、キャンセル料のお支払いが完了するまで、以下の機能が一時的に制限されます。<br/></span>
                  <span className="text-black text-base font-normal leading-7">・商品の新規出品<br/>・売上金の振込申請</span>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">着払い発送</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center">
                  <span className="text-black text-base font-normal leading-7">当社への商品発送は、必ず「元払い」でお手続きください。<br/>万が一、着払いで商品が届いた場合には、該当の送料を出品者様へご請求させていただきます。<br/>また、着払い金額のお支払いが確認できるまで、以下の機能を一時的に制限いたします。<br/></span>
                  <span className="text-black text-base font-normal leading-7">・商品の新規出品<br/>・売上金の振込申請<br/>・すべての商品の購入</span>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">海外からの発送</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  DONDONでは、海外からの商品の発送を禁止しております。<br/>
                  万が一、海外から発送された商品が確認された場合は、取引をキャンセルのうえ、登録されているご住所宛に着払いで商品を返送いたします。<br/>
                  ※返送先をご指定いただくことはできません。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">返送商品の持ち戻り</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  当社から返送した商品が持ち戻りとなった場合は、必ず2週間以内に事務局までご連絡ください。<br/>
                  ご連絡がないまま2週間を経過した場合は、商品を破棄させていただきますので、あらかじめご了承ください。
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">カスタマーハラスメントについて</div>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              DONDONでは、サービスの円滑な提供および従業員の安全確保のため、カスタマーハラスメント行為を固くお断りしております。
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">カスタマーハラスメントに該当する例</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="w-full justify-center">
                  <span className="text-black text-base font-normal leading-7">・威圧的・脅迫的・威嚇的な言動<br/>・侮辱や人格を否定する発言<br/>・従業員個人を対象とした攻撃や不適切な要求<br/>・社会通念を逸脱した過剰なサービスの要求<br/></span>
                  <span className="text-black text-base font-normal leading-7">このような行為が確認された場合には、サービスやサポートの提供を制限させていただく場合がございます。</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">利用制限について</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                事務局より迷惑行為と判断された場合、該当アカウントの一部機能またはすべてのご利用を制限させていただくことがあります。
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="w-full justify-center text-black text-base font-normal leading-7">
                  機能制限の内容や解除の条件など、詳細につきましては以下のページをご確認ください。
                </div>
                <Link to={`/terms/restrictions${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">利用制限について</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default SpamBehaviorPage;